import { Lock } from "@phosphor-icons/react";

/**
 * TapTrustBadge — small credibility strip shown near any "PAY WITH CARD" action.
 * Kept as pure CSS/SVG (no external images) so it never breaks CSP or dark mode.
 */
export default function TapTrustBadge({ variant = "compact", className = "" }) {
  const brands = ["VISA", "MC", "AMEX", "MADA"];
  return (
    <div
      data-testid="tap-trust-badge"
      className={`inline-flex items-center gap-2 text-[10px] font-mono tracking-[0.14em] uppercase text-zinc-500 ${className}`}
    >
      <Lock size={11} weight="bold" className="text-emerald-700" />
      <span className="whitespace-nowrap">Powered by Tap Payments</span>
      {variant !== "minimal" && (
        <span className="flex items-center gap-1" aria-label="Accepted cards">
          {brands.map((b) => (
            <span
              key={b}
              className="inline-block border border-zinc-300 bg-white text-zinc-700 px-1.5 py-0.5 text-[9px] font-bold leading-none"
              data-testid={`tap-brand-${b.toLowerCase()}`}
            >
              {b}
            </span>
          ))}
        </span>
      )}
    </div>
  );
}
